// eslint-disable-next-line es/no-typed-arrays -- safe
module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';



// WEBPACK FOOTER //
// webpack://pdfmake/node_modules/core-js/internals/array-buffer-native.js